export default "__VITE_ASSET__Dl$Ee5T$__"